import MapboxDraw, { DrawCustomMode } from "@mapbox/mapbox-gl-draw";
import { SnapLineMode } from "mapbox-gl-draw-snap-mode";

import { removeGuides } from "./helper";

const { constants: Constants } = MapboxDraw;

const drawLineString: DrawCustomMode = {
  ...SnapLineMode,

  onSetup: function (opts) {
    const state = SnapLineMode.onSetup?.call(this, opts);
    state.midPoints = this._ctx.options.midPoints !== false; // default to true if not set
    removeGuides.call(this);

    return state;
  },

  onClick: function (state, e) {
    SnapLineMode.onClick?.call(this, state, e);

    // If midpoints are disabled, we want to exit the mode after drawing a line with 2 points (i.e. a single segment)
    if (!state.midPoints && state.line.coordinates.length === 3) {
      this.changeMode(Constants.modes.SIMPLE_SELECT, { featureIds: [state.line.id] });
    }
  },
};

export default drawLineString;
